// removed by extract-text-webpack-plugin
module.exports = {"bg":"Background__bg__3Nkkd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Background/Background.css
// module id = 102
// module chunks = 0